<template>
    <section>
        <AppBackground :title="title"/>
        <v-container class="about__contents">
            <v-row class="about__contents-song" justify="center">
                <v-col>
                    <v-row>
                        <v-col>
                            <div class="content_title text-h5">校歌</div>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <img
                                src="../assets/img/aboutItem/song.webp"
                                class="about__contents-song-img"
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <audio controls>
                                <source src="../assets/song/song.mp3">
                            </audio>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-row class="about__contents-emb">
                <v-col>
                    <v-row>
                        <v-col>
                            <div class="text-h5 content_title">校章</div>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="about__contents-emb-img" >
                            <v-img
                                max-width="300"
                                src="../assets/img/aboutItem/emb.webp"
                            />
                        </v-col>
                        <v-col class="about__contents-emb-text" align-content="center">
                            <p class='text-h7'>松尾中学校が町の中心桔梗が丘に建築された機会に、九十九里の黒潮からの涼風をうけてうたう松風のさわやかさと、力強い雄々しさから松葉をとり入れ、校舎の円型からデザインしたものです。</p>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-row class="about__contents-history">
                <v-col>
                    <v-row>
                        <v-col>
                            <div class="text-h5 content_title">歴史年表</div>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-simple-table class="v-table">
                                <template v-slot:default>
                                    <tbody>
                                        <tr
                                            v-for="(hisItem, index) in hisItems"
                                            :key="index"
                                        >
                                        <td width="25%">{{ hisItem.time }}</td>
                                        <td width="75%">{{ hisItem.event1 }}</td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-container>
    </section>
</template>

<script>
import AppBackground from './AppBackgroundHolder.vue'
import constants from '../common/constants'

export default {
    name: "About",
    data () {
        return {
            title: '学校概要',
            hisItems: constants.hisItems
        }
    },
    components:{
        AppBackground
    }
}
</script>

// <style lang="scss" scoped>
@import "../styles/common/common.scss";

.content_title {
    padding: 1rem 2rem;
    border-top: 3px solid #000;
    border-bottom: 3px solid #000;
    text-align:  center;
}

.about__contents {
    &-song {
        margin-bottom: 100px;
        &-img {
            @include display_sp {
                max-width: 400px !important;
                padding: 0 !important;
            }
            @include display_pc {
                padding-left: 250px !important;
                max-width: 800px;
            }
            padding-left: 100px;
            max-width: 550px;
            text-align: center;
        }
    }
    &-emb {
        margin-bottom: 50px;
        &-img {
            display: flex;
            @include display_sp {
                padding-left: 40px !important;
            }
            @include display_pc {
                padding-left: 150px !important;
            }
        }
        &-text {
            min-width: 180px;
            max-width: 360px;
            @include display_pc {
                padding-right: -150px !important;
            }
        }
    }
    &-history {
        margin-bottom: 70px;
    }
}
</style>
